@if (myself) {
  <section class="user-settings-transactions" [attr.aria-labelledby]="'transactions-heading'">
    <app-cr-header id="transactions-heading" [headingLevel]="2">
      {{ 'USER_SETTINGS.USER_SETTINGS_TRANSACTIONS' | translate }}
    </app-cr-header>
    @if ((loadingPurchaseList$ | async) === false && (purchaseList$ | async)?.length && showPurchaseList) {
      <div class="purchases-list">
        <nz-collapse>
          @for (purchase of purchaseList$ | async; track purchase; let purchaseIndex = $index) {
            <nz-collapse-panel [nzHeader]="PurchaseHeader" [attr.aria-labelledby]="'purchase-' + purchaseIndex">
              <ng-template #PurchaseHeader>
                @if (purchase.status === PurchaseStatus.CLOSED) {
                  <span>
                    {{ 'PURCHASE.TRANSACTION_DATE' | translate }}
                    <b>{{ formatP24Date(purchase.paymentInfo.p24_transactionInfo?.dateOfTransaction) }}</b>
                  </span>
                  &nbsp; &nbsp;
                  <span>
                    {{ 'PURCHASE.TOTAL_AMOUNT_PAID' | translate }}
                    <b>{{ (purchase.totalAmountPaid / 100).toFixed(2) }} PLN</b>
                  </span>
                }
                @if (purchase.status !== PurchaseStatus.CLOSED) {
                  <span>
                    {{ 'PURCHASE.TRANSACTION_NOT_FINISHED' | translate }} -
                    {{ purchase.updatedAt | date: 'yyyy-MM-dd HH:mm' }}
                  </span>
                }
              </ng-template>
              @if (purchase.paymentInfo.p24_transactionInfo; as transactionInfo) {
                <ul role="presentation">
                  <li class="item">
                    <div class="app-list-item">
                      <b>{{ 'PURCHASE.TRANSACTION_STATEMENT_VISIBLE_IN_BANK_ACCOUNT_HISTORY' | translate }}</b>
                    </div>
                    <div class="app-list-item">
                      {{ transactionInfo.statement }}
                    </div>
                  </li>
                  <li class="item">
                    <div class="app-list-item">
                      <b>{{ 'PURCHASE.TRANSACTION_AMOUNT' | translate }}</b>
                    </div>
                    <div class="app-list-item">
                      {{ (purchase.totalAmountPaid / 100).toFixed(2) }} {{ purchase.paymentInfo.currency }}
                    </div>
                  </li>
                  <li class="item">
                    <div class="app-list-item">
                      <b>{{ 'PURCHASE.TRANSACTION_CURRENCY' | translate }}</b>
                    </div>
                    <div class="app-list-item">
                      {{ purchase.paymentInfo.currency }}
                    </div>
                  </li>
                </ul>
              }
              @if (purchase.products?.length) {
                <ul>
                  <li class="item">
                    <div class="app-list-item">
                      <b>{{ 'PURCHASE.PURCHASED_SERVICES' | translate }}</b>
                    </div>
                    @for (product of purchase.products; track product) {
                      <div
                        class="app-list-item"
                        role="text"
                        [attr.aria-label]="
                          product.name[currentLang] +
                          ', ' +
                          ('COMMON.LABEL.QUANTITY' | translate) +
                          ' ' +
                          product.quantity
                        ">
                        <span aria-hidden="true"> {{ product.name[currentLang] }} x{{ product.quantity }} </span>
                      </div>
                    }
                  </li>
                </ul>
              }
              @let purchaseApps = purchase.upsellUserProcess ? [purchase.upsellUserProcess] : purchase.userProcesses;
              @if (purchaseApps?.length) {
                <ul>
                  <li class="item">
                    <div class="app-list-item">
                      <b>{{ 'PURCHASE.SERVICES_IN_PROGRESS' | translate }}</b>
                    </div>
                    @for (app of purchaseApps; track app) {
                      <div class="app-list-item">
                        @if (app.status === UserProcessStatus.ARCHIVED) {
                          <span class="archived-item" [attr.aria-hidden]="true">
                            {{ 'APPLICATION.APPLICATION' | translate }}
                            {{ app.name }}
                            @if (app.personalDetails?.name || app.personalDetails?.surname) {
                              -
                              {{ app.personalDetails.name }}
                              {{ app.personalDetails.surname }}
                            }
                          </span>
                        } @else {
                          <a
                            class="in-app-link"
                            [routerLink]="['/user-process', app.id]"
                            [attr.aria-label]="
                              ('APPLICATION.APPLICATION' | translate) +
                              ' ' +
                              app.name +
                              (app.personalDetails?.name || app.personalDetails?.surname
                                ? ' - ' + app.personalDetails?.name + ' ' + app.personalDetails?.surname
                                : '') +
                              ', ' +
                              (app.hasFullHandling
                                ? ('COMMON.LAYOUT.HAS_FULL_HANDLING' | translate)
                                : app.hasAssistantService
                                  ? ('COMMON.LAYOUT.HAS_ASSISTANT_SERVICE' | translate)
                                  : ('COMMON.LAYOUT.HAS_BASIC_SUPPORT' | translate))
                            ">
                            {{ 'APPLICATION.APPLICATION' | translate }}
                            {{ app.name }}
                            @if (app.personalDetails?.name || app.personalDetails?.surname) {
                              -
                              {{ app.personalDetails.name }}
                              {{ app.personalDetails.surname }}
                            }
                          </a>
                        }
                        <span [attr.aria-hidden]="true">&nbsp;-&nbsp;</span>
                        <app-service-level-tag
                          [userProcess]="app"
                          [mode]="PurchaseTags.LARGE"
                          [attr.aria-hidden]="true"></app-service-level-tag>
                        @if (app.status === UserProcessStatus.ARCHIVED) {
                          <span [attr.aria-hidden]="true">
                            &nbsp; - &nbsp; {{ 'COMMON.GENERAL.ARCHIVED' | translate }}
                          </span>
                        }
                      </div>
                    }
                  </li>
                  <li class="action-button">
                    @if (purchase.purchaseDocumentId) {
                      <button type="button" nz-button nzType="primary" (click)="downloadPurchaseDocument(purchase)">
                        {{ 'PURCHASE.DOWNLOAD_PURCHASE_DOCUMENT' | translate }}
                      </button>
                    }
                    @if (!purchase.purchaseDocumentId) {
                      <span>
                        {{ 'PURCHASE.PURCHASE_DOCUMENT_NOT_AVAILABLE' | translate }}
                      </span>
                    }
                  </li>
                </ul>
              }
            </nz-collapse-panel>
          }
        </nz-collapse>
      </div>
    }
    @if ((loadingPurchaseList$ | async) === false && (purchaseList$ | async)?.length === 0) {
      <div class="empty-purchases-list">
        <nz-empty></nz-empty>
      </div>
    }
    @if ((loadingPurchaseList$ | async) === true) {
      <div class="loading-container-in-section" role="status" aria-live="polite">
        <span class="sr-only">
          {{ 'COMMON.LAYOUT.LOADING' | translate }}
        </span>
        <mat-spinner [diameter]="50" [attr.aria-hidden]="true"></mat-spinner>
        <div class="spinner-message" [innerHTML]="'USER_SETTINGS.LOADING_PURCHASE_HISTORY' | translate"></div>
      </div>
    }
  </section>
}
